/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-comment': {
    width: 18,
    height: 16,
    viewBox: '0 0 18 16',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M16.42 9.241c2.085-2.085 2.11-5.49.055-7.606a5.355 5.355 0 00-7.477-.222 5.355 5.355 0 00-7.42.166C-.507 3.665-.529 7.07 1.527 9.185l.05.05 6.216 6.253a1.67 1.67 0 002.388.021l.02-.021L16.42 9.24zm-7.421 4.621l6.007-6.035a3.435 3.435 0 00.034-4.799l-.004-.005a3.356 3.356 0 00-4.687-.135l-1.35 1.235-1.35-1.234a3.355 3.355 0 00-4.657.104 3.435 3.435 0 000 4.828l.003.004L9 13.862z" _fill="#646464"/>'
  }
})
